import { List, Empty, InfiniteScroll, PullToRefresh } from 'antd-mobile'
import dayjs from 'dayjs';
import nodata from "static/images/nodata.svg";
import { BpmApplyResult } from "components/ApplyResult/BpmApplyResult";
import { reviewType } from 'utils/constant';

/** 申请结果 */
export function ApplyResultCard(props) {
  const { list, ScrollList, hasMore, toRefresh, loading } = props
  const { FAIL } = reviewType

  return (
    <PullToRefresh
      onRefresh={toRefresh}
    >
      {
        list.length === 0 && loading === false ?
          <div>
            <Empty
              className='empty'
              image={nodata}
              description='暂无数据'
              imageStyle={{ width: 128 }}
            />
          </div>
          :
          <div className="tabs">
            <List>
              {
                list.map((item, index) => (
                  <div key={index}>
                    <List.Item
                      key={list.applynum}
                      extra={
                        <BpmApplyResult result={item.result} resultflag={item.resultflag} />
                      }
                    >
                      <div className="applyTitle">
                        {item.itemname}
                      </div>
                      <div className="applyCont">
                        受理时间：{dayjs(item.receivetime).format('YYYY-MM-DD HH:mm:ss')}
                      </div>
                      <div className="applyCont">
                        受理部门：{item.department}
                      </div>
                      {
                        item.resultflag === FAIL &&
                        <div className="applyCont">
                          结果说明：
                          <span className="red">
                            未满足申请条件
                          </span>
                        </div>
                      }
                    </List.Item>
                  </div>
                ))
              }
            </List>
            {/* 上拉加载 */}
            <InfiniteScroll loadMore={ScrollList} hasMore={hasMore} />
          </div >
      }
      {/* 下拉刷新 */}
    </PullToRefresh>
  )
}